var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1ProjektstandortActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 83.029,
    height: 83.03,
    viewBox: "0 0 83.029 83.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1956",
    "data-name": "Rechteck 1956",
    width: 83.029,
    height: 83.03,
    fill: "#e3e3e3",
    stroke: "#fff",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1-projektstandort-active",
    "data-name": "1-projektstandort-active",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_661",
    "data-name": "Gruppe 661",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4103",
    "data-name": "Pfad 4103",
    d: "M82.684,41.93A40.754,40.754,0,1,1,41.929,1.176,40.754,40.754,0,0,1,82.684,41.93",
    transform: "translate(-0.415 -0.415)",
    fill: "#003763",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4104",
    "data-name": "Pfad 4104",
    d: "M41.514,83.03A41.515,41.515,0,1,1,83.03,41.515,41.562,41.562,0,0,1,41.514,83.03m0-81.508A39.994,39.994,0,1,0,81.508,41.515,40.039,40.039,0,0,0,41.514,1.521",
    transform: "translate(0)",
    fill: "#00467d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4105",
    "data-name": "Pfad 4105",
    d: "M53.368,73.545c-.417,0-.492,0-3.24-3.149-1.418-1.625-3.565-4.184-5.742-7.146-5.588-7.6-8.421-13.726-8.421-18.2a17.4,17.4,0,1,1,34.808,0c0,10.445-11.478,22.949-16.414,27.84l-.178.175-.248.233Zm0-44.277a15.8,15.8,0,0,0-15.78,15.78c0,9.4,14.726,25.4,15.353,26.08l.867.015c5.73-5.779,15.341-16.855,15.341-26.094a15.8,15.8,0,0,0-15.78-15.78",
    transform: "translate(-12.699 -9.762)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4106",
    "data-name": "Pfad 4106",
    d: "M59.723,59.826a7.169,7.169,0,1,1,7.17-7.17,7.178,7.178,0,0,1-7.17,7.17m0-12.715a5.546,5.546,0,1,0,5.545,5.545,5.551,5.551,0,0,0-5.545-5.545",
    transform: "translate(-18.557 -16.062)",
    fill: "#00c713",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4107",
    "data-name": "Pfad 4107",
    d: "M59.723,59.826a7.169,7.169,0,1,1,7.17-7.17,7.178,7.178,0,0,1-7.17,7.17m0-12.715a5.546,5.546,0,1,0,5.545,5.545,5.551,5.551,0,0,0-5.545-5.545",
    transform: "translate(-18.557 -16.062)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1ProjektstandortActive);
export default __webpack_public_path__ + "static/media/1-projektstandort-active.d2d112dec10870b02d428e141bbd1955.svg";
export { ForwardRef as ReactComponent };